import { createGlobalStyle } from 'styled-components';

import Background from '../assets/background.png';

import Info from '../assets/messageIcon/info.svg';
import Error from '../assets/messageIcon/error.svg';
import Success from '../assets/messageIcon/success.svg';
import Warning from '../assets/messageIcon/warning.svg';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: url(${Background}) repeat top;
    color: #F4F4F4;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: 'Noto Sans', sans-serif;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  .Toastify__toast--info {
    .Toastify__toast-body{
      display: flex;
       align-items: center;
      ::before  {
      content:url(${Info});
      width: 50px;
      height: 50px;
    }
    }
    background-color: #63B2E6;  
}
.Toastify__toast--success {
  .Toastify__toast-body{
      display: flex;
       align-items: center;
      ::before  {
      content:url(${Success});
      width: 50px;
      height: 50px;
    }
    }
  background-color: #62C744;
}
.Toastify__toast--warning {
  .Toastify__toast-body{
      display: flex;
       align-items: center;
      ::before  {
      content:url(${Warning});
      width: 50px;
      height: 50px;
    }
    }
  background-color: #FFBF00;
}
.Toastify__toast--error {
  .Toastify__toast-body{
      display: flex;
       align-items: center;
      ::before  {
      content:url(${Error});
      width: 50px;
      height: 50px;
    }
    }
  background-color: #E81919;
}

  .modal-dialog{
    max-width: 800px
  }
  .modal-header {
    font-weight: 500;
    background-color: #1a2530;
    border-bottom: 0;
    span {
      color: #f4f4f4;
    }
  }

  .modal-content {
    background-color: #32404e;
  }

  .modal-body ul {
    padding-left: 19px;
  }

  .modal-body p {
    img {
      width: 50px;
      height: 50px;
    }
  }
`;
